const conf = {
  default: {
    dictionary: 'reset',
    displayBackBtn: false,
  },
  euija: {
    reset: {
      dictionary: 'euija',
      confirmButtonUrl: window.reactAppEnv.orangeAuth + '?return_url=' + encodeURIComponent(window.reactAppEnv.href.journalActivites + '?origin=managep'),
      displayBackBtn: true,
    },
  },
  mbalp: {
    reset: {
      dictionary: 'multibal',
    },
  },
};

export default conf;